/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostSpendByCloudTenantWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("CostSpendByCloudTenantWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return CostSpendByCloudTenantWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<CostSpendByCloudTenantWidgetConfiguration>): CostSpendByCloudTenantWidgetConfiguration {
        let obj = Object.assign(new CostSpendByCloudTenantWidgetConfiguration(), model);
        CostSpendByCloudTenantWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostSpendByCloudTenantWidgetConfiguration>): CostSpendByCloudTenantWidgetConfiguration {
        if (!model) return null;
        return CostSpendByCloudTenantWidgetConfiguration.newInstance(<CostSpendByCloudTenantWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostSpendByCloudTenantWidgetConfiguration) {
        if (!obj) return;

        models.CostSpendByCloudTenantWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostSpendByCloudTenantWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostSpendByCloudTenantWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
